module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', {
    staticClass: "parent-link",
    on: {
      "click": function($event) {
        _vm.navToHome()
      }
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', [_vm._v(" >> ")]), _vm._v(" "), _c('span', [_vm._v("EasyView Accounts Management")])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA),
      expression: "tabA"
    }]
  }, [_c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item intro-text"
  }, [_c('p', [_vm._v("Please submit the HCP account information for creating a new HCP account.")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('country_region')) + ":")]), _vm._v(" "), (!_vm.isCN) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.country_region),
      expression: "profile.country_region"
    }],
    staticClass: "country_region",
    attrs: {
      "id": "country_region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.country_region = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GB"
    }
  }, [_vm._v("United Kingdom (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AU"
    }
  }, [_vm._v("Australia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HKF"
    }
  }, [_vm._v("香港(中国) (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TH"
    }
  }, [_vm._v("Thailand (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Indonesia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MY"
    }
  }, [_vm._v("Malaysia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("India (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("France (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Deutschland (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DD"
    }
  }, [_vm._v("Deutschland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HU"
    }
  }, [_vm._v("Magyarország (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("Italia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("Nederland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nor"
    }
  }, [_vm._v("Norge (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PT"
    }
  }, [_vm._v("Portugal (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("España (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("Sverige (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TR"
    }
  }, [_vm._v("Turkey (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ro"
    }
  }, [_vm._v("Romania (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CZ"
    }
  }, [_vm._v("Czech republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v("Slovenska republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LT"
    }
  }, [_vm._v("Lithuania (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PL"
    }
  }, [_vm._v("Polska (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DK"
    }
  }, [_vm._v("Danmark (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FI"
    }
  }, [_vm._v("Suomi (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CH"
    }
  }, [_vm._v("Switzerland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("Saudi  (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AE"
    }
  }, [_vm._v("United Arab (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QA"
    }
  }, [_vm._v("Qatar  (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QW"
    }
  }, [_vm._v("Kuwait (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RH"
    }
  }, [_vm._v("Croatia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AT"
    }
  }, [_vm._v("Austria (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SI"
    }
  }, [_vm._v("Slovenia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EE"
    }
  }, [_vm._v("Estonia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LV"
    }
  }, [_vm._v("Latvia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("Bosnia and Herzegovina (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v("Bulgaria (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CL"
    }
  }, [_vm._v("Chile (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BE"
    }
  }, [_vm._v("Belgium (mg/L)")])]) : _c('label', {
    staticClass: "ID2"
  }, [_vm._v("中国 (mmol/L)")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    class: {
      'es5': _vm.isIt || _vm.isFr || _vm.isDe || _vm.isEs || _vm.isDu || _vm.isPo || _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.realname),
      expression: "profile.realname"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.realname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Organization')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.serve_for),
      expression: "profile.serve_for"
    }],
    staticClass: "name org",
    class: {
      'zh2': !_vm.isEn, 'es2': _vm.isEs, 'it2': _vm.isIt, 'cz2': _vm.isCz
    },
    domProps: {
      "value": (_vm.profile.serve_for)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.serve_for = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.mobile),
      expression: "profile.mobile"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.mobile = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'opeP': _vm.isP
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "create",
    on: {
      "click": _vm.create2
    }
  }, [_vm._v("Create")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabB),
      expression: "tabB"
    }]
  }, [_c('p', {
    staticClass: "update-to-hcp-text"
  }, [_vm._v("\n            This email address has been used by a patient account. If you want to switch to an HCP account, choose Next. "), _c('br'), _vm._v("\n            Please note that once the account type is changed, any account data will be lost, and you can’t log in anymore to this account on EasyTouch, EasySense or EasyPatch.\n\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'opeP': _vm.isP
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "create",
    on: {
      "click": _vm.nextProc
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.backProc
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabC),
      expression: "tabC"
    }]
  }, [_c('p', {
    staticClass: "update-to-hcp-text"
  }, [_vm._v("\n            This email address has been used by a caregiver account. If you want to switch to an HCP account, choose Next. "), _c('br'), _vm._v("\n            Please note that once the account type is changed, any account data will be lost, and you can’t log in anymore to this account on EasyFollow.\n\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: {
      'opeP': _vm.isP
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "create",
    on: {
      "click": _vm.nextProc
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.backProc
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabD),
      expression: "tabD"
    }]
  }, [_c('div', {
    staticClass: "success_wrap"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/icon_ok.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Account created.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "add_new",
    on: {
      "click": _vm.addNewProc
    }
  }, [_vm._v("+ Add new account")])]), _vm._v(" "), _c('div', {
    staticClass: "success_wrap"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab8c68e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-templates/create-hcp.vue
// module id = 1441
// module chunks = 7